// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CapabilitySet } from './capability-set';
import {
    CapabilitySetFromJSON,
    CapabilitySetFromJSONTyped,
    CapabilitySetToJSON,
    CapabilitySetToJSONTyped,
} from './capability-set';

/**
 * 
 * @export
 * @interface CapabilitySetListResponse
 */
export interface CapabilitySetListResponse {
    /**
     * Whether this deployment allows creating and editing capability sets in the app.
     * @type {boolean}
     * @memberof CapabilitySetListResponse
     */
    editing_enabled: boolean;
    /**
     * 
     * @type {Array<CapabilitySet>}
     * @memberof CapabilitySetListResponse
     */
    items: Array<CapabilitySet>;
    /**
     * Opaque token for the next page; absent on the last page.
     * @type {string}
     * @memberof CapabilitySetListResponse
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the CapabilitySetListResponse interface.
 */
export function instanceOfCapabilitySetListResponse(value: object): value is CapabilitySetListResponse {
    if (!('editing_enabled' in value) || value['editing_enabled'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function CapabilitySetListResponseFromJSON(json: any): CapabilitySetListResponse {
    return CapabilitySetListResponseFromJSONTyped(json, false);
}

export function CapabilitySetListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapabilitySetListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'editing_enabled': json['editing_enabled'],
        'items': ((json['items'] as Array<any>).map(CapabilitySetFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function CapabilitySetListResponseToJSON(json: any): CapabilitySetListResponse {
    return CapabilitySetListResponseToJSONTyped(json, false);
}

export function CapabilitySetListResponseToJSONTyped(value?: CapabilitySetListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'editing_enabled': value['editing_enabled'],
        'items': ((value['items'] as Array<any>).map(CapabilitySetToJSON)),
        'nextToken': value['nextToken'],
    };
}
